// Format an integer into a locale-sensitive string e.g., 4567890 -> '4,567,890';
// Note: this function assumes the output is an integer e.g., '0500.50' -> '500'
function displayInteger(input) {
  const coercedValue = parseInt(input)
  if (!isFinite(coercedValue)) return '-'
  return coercedValue.toLocaleString('en-US')
}

export default displayInteger
